enum LocalStoreKey {
    LOCALSTORE_TOKEN = 'LOCALSTORE_KEY',
    LOCALSTORE_CART = 'LOCALSTORE_CART',
    LOCALSTORE_CART_NAME = 'LOCALSTORE_CART_NAME'
}

const LocalStoreManager = {
    get: (key: LocalStoreKey) => {
        let item = localStorage.getItem(key)
        if (!item || item === 'undefined' ) return null;
        return JSON.parse(item)
    },
    set: (key: string, value: any) => {
        localStorage.setItem(key, JSON.stringify(value));
    },
    setAsync: async (key: string, value: any) => {
        localStorage.setItem(key, JSON.stringify(value));
    },
    remove: (key: string) => {
        localStorage.removeItem(key);
    }
}

export { LocalStoreManager, LocalStoreKey }
